import React from "react";
import { SESSION_STORAGE_KEYS } from '../const/AppConst';
import useAppState from "../context/AppContext";
import { INomenclature } from "../context/model";
import { getNomenclature } from '../services/CustomerApiService';
import { useSessionStorage } from "../utils/utils";

export const useFetchNomenclature = (nomenclatureId: 'csp' | 'civility' | 'familySituation' | 'country' | 'radiationReason' | 'radiationInfo' | 'affiliationTypology' | 'regime' | 'department', hasSorted?: boolean): INomenclature => {
  const {
    state: { jwtToken },
  } = useAppState();
  const [nomenclature, setNomenclature] = useSessionStorage(SESSION_STORAGE_KEYS.nomenclatures + nomenclatureId, {} as INomenclature);
  async function fetchNomenclature(nomenclatureId: string) {
    try {
      const payload = await getNomenclature(jwtToken!.accessToken, nomenclatureId);
      if(hasSorted) {
        payload.data.options.sort((a,b) => a.label.localeCompare(b.label));
      }
      
      setNomenclature(payload.data);
    } catch (error) {
     
    }
  }
  React.useEffect(() => {
    let ignore = false;
    if(!nomenclature?.options || nomenclature.options.length === 0) {
      fetchNomenclature(nomenclatureId);
    }
    return () => {
      ignore = true;
    };
  }, []);

  return nomenclature;
};
